import { PortableText, PortableTextBlock } from '@portabletext/react'
import Image from 'next/image'

import { AttributeRenderer, Normal } from './shared'
import { CompareCredit } from '../../../../types'
import { nextImageHelper } from '../../../utils'

export const V1Layout: React.FC<{
  details: Array<{
    _key: string
    description: PortableTextBlock[]
    headline: string
    icon: any
  }>
  referencedCards: null | Record<string, CompareCredit.Entity>
}> = ({ details, referencedCards }) => {
  return (
    <div className="c-botline-v1 / mx-auto mt-4 mb-8 / leading-[1.5]">
      <h2 className="c-botline-v1__title / text-2xl font-extrabold text-primary mb-2">
        Bottom Line:
      </h2>
      <ul className="c-botline-v1__list / flex flex-col sm:flex-row sm:flex-wrap">
        {details.map(({ _key, description, headline, icon }) => {
          return (
            <li
              key={_key}
              className={
                'c-botline-v1__item / flex items-start space-x-3 shrink-0 / sm:w-1/2 / mb-2 sm:mb-0'
              }
            >
              <div className="c-botline-v1__icon / shrink-0 / flex w-10 h-10 / pt-1">
                <Image
                  alt={headline}
                  height={38}
                  placeholder="blur"
                  blurDataURL={icon.metadata.lqip}
                  src={icon.url}
                  width={38}
                  style={nextImageHelper.intrinsic}
                  className="w-full"
                />
              </div>

              <div className="c-botline-v1__content">
                <h3 className="c-botline-v1__list-title / mb-1 / text-2xl sm:text-lg font-bold text-primary leading-tight">
                  {headline}
                </h3>
                <div className="c-botline-v1__list-text / text-sm text-gray-700">
                  <PortableText
                    value={description}
                    components={{
                      block: {
                        normal: Normal,
                      },
                      types: {
                        advertorialAttribute:
                          AttributeRenderer(referencedCards),
                      },
                    }}
                  />
                </div>
              </div>
            </li>
          )
        })}
      </ul>
      <style jsx>{`
        @media (min-width: 640px) {
          .c-botline-v1__item {
            padding-left: 1rem;
            padding-bottom: 2rem;
          }
          .c-botline-v1__item:nth-child(2n + 1) {
            padding-left: 0;
            padding-right: 1rem;
            border-right: 1px solid #dce4ee;
          }
          .c-botline-v1__item:nth-child(3),
          .c-botline-v1__item:nth-child(4) {
            padding-bottom: 0;
          }
        }
      `}</style>
    </div>
  )
}
